import { z } from 'zod';
export const StartTranscriptionQueryRequestSchema = z.object({
    m: z.string(),
});
export const StartTranscriptionRequestSchema = StartTranscriptionQueryRequestSchema;
